<template>
  <div class="booking-header-extension">
    <div class="booking-header-extension-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'booking-header-extension',
  props: {
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
  },
  methods: {
    login() {
      console.log('login')
    }
  }
}
</script>
